import { render, staticRenderFns } from "./JobAlertList.vue?vue&type=template&id=8b20ff96&scoped=true&"
import script from "./JobAlertList.vue?vue&type=script&lang=js&"
export * from "./JobAlertList.vue?vue&type=script&lang=js&"
import style0 from "./JobAlertList.vue?vue&type=style&index=0&id=8b20ff96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b20ff96",
  null
  
)

export default component.exports